import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import "./index.css";
import { ThemeContextProvider } from "./Misc/ThemeContext";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { I18nextProvider } from "react-i18next";
import i18n from "./Misc/i18nConfig";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ThemeContextProvider>
      <I18nextProvider i18n={i18n}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nextProvider>
    </ThemeContextProvider>
  </Provider>
);
